import { t } from 'i18next'
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const TollingAccountPage = lazy(() => import('../containers/TollingAccount/TollingAccountContainer'))

export const TOLLING_ACCOUNT_PATHS = {
  HOME: '/tolling-account',
} as const

export const tollingAccountRoutes: RouteObject[] = [
  {
    path: TOLLING_ACCOUNT_PATHS.HOME,
    children: [
      {
        index: true,
        element: <TollingAccountPage />,
        handle: {
          crumb: (): MenuItem[] => [
            { label: t('general:menu.tolling_account') || '', url: TOLLING_ACCOUNT_PATHS.HOME },
          ],
        },
      },
    ],
  },
]
